/**
 * The personal notification inbox behind the header bell.
 *
 * The trigger's name CARRIES THE COUNT, because the badge is a picture: a
 * screen reader hears "3 unread notifications" where the eye sees the number
 * on the bell. The count picks its own id — English happens to inflect with an
 * "s", Hebrew does not form its plural that way, so `One`/`Many` are separate
 * sentences exactly as the Task counts are.
 */
export const notifications = {
  'notifications.trigger': 'Notifications',
  'notifications.triggerUnreadOne': '1 unread notification',
  'notifications.triggerUnreadMany': '{count} unread notifications',
  'notifications.title': 'Notifications',
  'notifications.markAllRead': 'Mark all read',
  'notifications.loading': 'Loading notifications',
  'notifications.loadFailed': 'Notifications could not be loaded.',
  'notifications.empty': 'Nothing to catch up on',
  'notifications.emptyDetail': 'Task reminders sent to you in the app appear here.',
  'notifications.unread': 'Unread',
  'notifications.newestShown': 'Showing the newest {count}',
  'notifications.markReadFailed': 'That notification could not be marked read.',
  'notifications.markAllFailed': 'The inbox could not be marked read.',
  'notifications.actionForbidden': 'This account cannot acknowledge notifications.',
  'notifications.actionUnavailable': 'Notifications are unavailable. Try again shortly.',
  'notifications.rowGone': 'That notification is no longer in your inbox.',
} as const
